import { useCallback, useEffect, useMemo, useState } from 'react'

const getNext = (prev, max) => {
  return prev === max ? 0 : prev + 1
}

let intervalId
export const useEachOnInterval = (items, ms, paused) => {
  const [current, setCurrent] = useState(0)
  const hasMoreThanOneItem = useMemo(() => items.length > 1, [items])
  const cb = useCallback(() => {
    if (hasMoreThanOneItem && !paused) {
      setCurrent((prev) => getNext(prev, items.length - 1))
    }
  }, [items.length, paused, hasMoreThanOneItem])

  useEffect(() => {
    if (hasMoreThanOneItem) {
      intervalId = setInterval(cb, ms)
    }
    return () => {
      if (hasMoreThanOneItem) {
        clearInterval(intervalId)
      }
    }
  }, [ms, cb, hasMoreThanOneItem])

  return items[current]
}

export default useEachOnInterval
